<template>
  <div class="flex flex-col flex-1 min-w-0 h-full">
    <div class="box-header">
      <div class="box-title"> {{ $tc('announcement', 2) }} </div>
      <div class="box-action">
        <FlotoLink
          v-if="announcements.length > allAnnouncements.length"
          :to="viewAllLink"
        >
          <MIcon name="view-more" size="2x" />
        </FlotoLink>
        <MIcon v-else name="announcement" size="2x" />
      </div>
    </div>
    <MDivider class="mt-1 my-4" />
    <MRow class="flex-no-wrap flex-col min-w-0">
      <MCol
        v-for="(announcement, index) in allAnnouncements"
        :key="announcement.id"
        class="flex-1 min-w-0 mb-4 flex flex-col"
      >
        <div class="flex min-w-0">
          <div class="time-box">
            <div class="month">{{
              Moment(announcement.updatedAt).format('MMM')
            }}</div>
            <div class="date">{{
              Moment(announcement.updatedAt).format('DD')
            }}</div>
          </div>
          <div class="flex flex-1 flex-col min-w-0 mx-2">
            <a
              class="item-name text-ellipsis min-w-0"
              @click="viewAnnouncement(announcement)"
            >
              <span class="text-ellipsis">
                {{ announcement.name }}
              </span>
            </a>
            <small
              v-if="(announcement.owner || {}).name"
              class="item-creater text-ellipsis block"
            >
              {{ $t('by') }}: {{ (announcement.owner || {}).name }}
            </small>
          </div>
        </div>
      </MCol>
    </MRow>
    <FlotoDrawer
      :open="Boolean(currentAnnouncement)"
      :scrolled-content="false"
      @hide="currentAnnouncement = null"
    >
      <template v-if="currentAnnouncement" v-slot:title>
        <div class="flex items-center">
          <MIcon name="bullhorn" size="lg" class="mr-2" />
          {{ $tc('announcement') }}
        </div>
      </template>
      <AnnouncementView
        v-if="currentAnnouncement"
        :announcement="currentAnnouncement"
      />
      <template v-if="currentAnnouncement" v-slot:actions="{ hide }">
        <MButton variant="default" @click="hide">{{ $t('close') }}</MButton>
      </template>
    </FlotoDrawer>
  </div>
</template>

<script>
import Moment from 'moment'
import AnnouncementView from '@components/announcement/announcement-view.vue'
import {
  TechnicianComputed,
  TechnicianMethods,
} from '@state/modules/technician'
import { authComputed } from '@state/modules/auth'
import { PreferenceComputed } from '@state/modules/preference'
export default {
  name: 'AnnouncementCard',
  components: { AnnouncementView },
  props: {
    announcements: { type: Array, required: true },
    viewAllLink: { type: Object, required: true },
  },
  data() {
    this.Moment = Moment
    return {
      currentAnnouncement: null,
    }
  },
  computed: {
    ...authComputed,
    ...TechnicianComputed,
    ...PreferenceComputed,
    allAnnouncements() {
      return this.announcements
        .slice(0, 4)
        .map((a) => ({ ...a, owner: this.owner(a.createdBy) }))
    },
  },
  created() {
    this.fetchTechnicians()
  },
  methods: {
    ...TechnicianMethods,
    owner(id) {
      if (id === -93102) {
        return {
          name: this.$tc('system'),
        }
      }
      return this.technician(id)
    },
    viewAnnouncement(a) {
      this.currentAnnouncement = a
    },
  },
}
</script>

<style lang="less" scoped>
.box-header {
  @apply flex justify-between items-center min-w-0;

  & .box-title {
    @apply flex pb-1;

    font-size: 0.898rem;
    font-weight: 500;
    color: var(--primary-alt);
  }

  & .box-action {
    color: var(--primary);
  }
}

.item-name {
  font-weight: 500;
  color: var(--text-color);
}

.item-creater {
  color: var(--primary);
}

.time-box {
  @apply flex flex-col self-center rounded items-center justify-center p-2;

  width: 41px;
  height: 41px;
  color: var(--primary-alt);
  border: 2px solid var(--primary-alt);

  & .month {
    font-size: 10px;
    line-height: 15px;
  }

  & .date {
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
  }
}
</style>
